import {
  NFC_LANDING_PAGE,
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_CART,
  PAGE_TYPE_CART_INTERMEDIATE,
  PAGE_TYPE_REDEEM_E_RECIPE,
  PRESCRIPTION_MANAGER,
  TYPE_CROSSSELL_LAYOUT,
} from 'shared/consts'
import store from 'shared/store'
import buildClientAPI from 'views/providers/clientAPI'
import createA11Dialog from 'views/utils/createA11Dialog'

const showCrosssellModal = (delay: number) => {
  const modalContainer = <HTMLElement>(
    document.getElementById(TYPE_CROSSSELL_LAYOUT)
  )
  const crosssellLayoutShown = localStorage.getItem('crosssellLayoutShown')

  if (modalContainer && !crosssellLayoutShown) {
    const modal = createA11Dialog({
      element: modalContainer,
    })

    const crosssellLayoutTimeout = setTimeout(() => {
      modal.show()
      localStorage.setItem('crosssellLayoutShown', '1')
      modalContainer
        .querySelectorAll('[data-qa-id="seller-name"]')
        .forEach(sellerLink => {
          sellerLink.addEventListener('click', () => {
            modal.hide()
          })
        })
      clearTimeout(crosssellLayoutTimeout)
    }, delay)

    document
      .querySelector('.o-CrosssellLayout__go-back')
      ?.addEventListener('click', () => modal.hide())
  }
}

const BLACKLISTED_PAGES = [
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_CART,
  PAGE_TYPE_CART_INTERMEDIATE,
  PAGE_TYPE_REDEEM_E_RECIPE,
]

export default async () => {
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { mountPoints } = publicRuntimeConfig?.publicConfig || {}
  const { pageType = '', searchUrl } = publicRuntimeConfig?.pageProperties || {}
  const delay = 150000
  const { cartServiceV3 } = buildClientAPI()
  const miniCart = await cartServiceV3.fetchMiniCart()
  const cartQuantity = miniCart?.data?.entriesInCart || 0

  const blacklistedUrls = [
    mountPoints[PRESCRIPTION_MANAGER],
    mountPoints[NFC_LANDING_PAGE],
    '/magazin/e-health/e-rezept/',
    '/lp/rezeptbonus/',
  ]

  if (
    BLACKLISTED_PAGES.includes(pageType) ||
    blacklistedUrls.includes(searchUrl) ||
    cartQuantity !== 0
  ) {
    return
  }
  showCrosssellModal(delay)
}
